import { Component, Input, EventEmitter, Output, OnDestroy, OnChanges } from '@angular/core';
import { MultiSubscriptionComponent } from '@ddv/common-components';
import { Entitlement, UserEntitlements } from '@ddv/entitlements';
import { Workspace } from '@ddv/layout';
import { UserPreferences } from '@ddv/models';

@Component({
    selector: 'app-hs-dashboard-header-menu',
    templateUrl: 'hs-dashboard-header-menu.component.html',
    styleUrls: ['./hs-dashboard-header-menu.component.scss'],
    standalone: false,
})
export class HSDashboardHeaderMenuComponent extends MultiSubscriptionComponent implements OnChanges, OnDestroy {
    @Input() inPresentationMode = false;
    @Input() currentDashboard: Workspace | undefined;
    @Input() isMultiClient = false;
    @Input() userPreferences: UserPreferences | undefined;
    @Input() includeExports = true;
    @Input() entitlements: UserEntitlements | undefined;

    @Output() restoreClicked = new EventEmitter();
    @Output() refreshClicked = new EventEmitter();
    @Output() queryParamApply = new EventEmitter();

    showExportOptions = false;
    userCanExport = false;

    ngOnChanges(): void {
        this.userCanExport = !!this.entitlements?.hasPermission(Entitlement.EXPORT);
    }

    toggleExportOptions(): void {
        if (this.userCanExport) {
            this.showExportOptions = !this.showExportOptions;
        }
    }

    closeDashboardExport(): void {
        this.showExportOptions = false;
    }
}
